import { Category } from '@/types/market';

export const categories: Category[] = [
  { id: 'cyprus-politics', name_en: 'Cyprus Politics', name_gr: 'Πολιτική Κύπρου' },
  { id: 'cyprus-economy', name_en: 'Cyprus Economy', name_gr: 'Οικονομία Κύπρου' },
  { id: 'cyprus-energy', name_en: 'Cyprus Energy', name_gr: 'Ενέργεια Κύπρου' },
  { id: 'cyprus-real-estate', name_en: 'Cyprus Real Estate', name_gr: 'Ακίνητα Κύπρου' },
  { id: 'greece-politics', name_en: 'Greece Politics', name_gr: 'Πολιτική Ελλάδας' },
  { id: 'greece-economy', name_en: 'Greece Economy', name_gr: 'Οικονομία Ελλάδας' },
  { id: 'greece-energy', name_en: 'Greece Energy', name_gr: 'Ενέργεια Ελλάδας' },
  { id: 'greece-real-estate', name_en: 'Greece Real Estate', name_gr: 'Ακίνητα Ελλάδας' },
  { id: 'sports-greece', name_en: 'Sports Greece', name_gr: 'Αθλητικά Ελλάδας' },
  { id: 'sports-cyprus', name_en: 'Sports Cyprus', name_gr: 'Αθλητικά Κύπρου' },
  { id: 'crypto', name_en: 'Crypto', name_gr: 'Κρυπτονομίσματα' },
  { id: 'global-markets', name_en: 'Global Markets', name_gr: 'Παγκόσμιες Αγορές' },
];
